{
  "gemPacks": [
    {
      "id": "gems_550",
      "gems": 500,
      "bonus": 50,
      "price": "$4.99",
      "priceTry": "179 TL"
    },
    {
      "id": "gems_1200",
      "gems": 1000,
      "bonus": 200,
      "price": "$9.99",
      "priceTry": "349 TL"
    },
    {
      "id": "gems_3000",
      "gems": 2400,
      "bonus": 600,
      "price": "$19.99",
      "priceTry": "699 TL"
    },
    {
      "id": "gems_8000",
      "gems": 6000,
      "bonus": 2000,
      "price": "$49.99",
      "priceTry": "1.749 TL"
    }
  ],
  "premium": [
    {
      "id": "premium_30",
      "name": "Gold Premium, 30 days",
      "days": 30,
      "gems": 500
    }
  ],
  "premiumPerks": {
    "xpPct": 100,
    "goldPct": 30,
    "dropPct": 10,
    "npPct": 5,
    "autoLootGoldRangeM": 30,
    "keepXpOnDeath": true
  },
  "skins": [
    {
      "id": "skin_crimson",
      "name": "Crimson Knight",
      "gems": 400,
      "days": 30,
      "main": "#9a1e1e",
      "trim": "#e8c050",
      "dark": "#4a0e0e",
      "cloth": "#6a1414",
      "glow": "#ff7a2a",
      "style": "horned",
      "fx": "embers",
      "desc": "Blood-red plate with gold filigree, black horns and spiked shoulders. Embers rise from your armor."
    },
    {
      "id": "skin_frost",
      "name": "Frost Warden",
      "gems": 400,
      "days": 30,
      "main": "#bfe6ff",
      "trim": "#ffffff",
      "dark": "#5a8ab4",
      "cloth": "#2a5a8a",
      "glow": "#7af0ff",
      "style": "crystal",
      "fx": "frost",
      "desc": "Ice-blue plate crowned with glowing ice shards. Snowflakes circle you and frost rings your feet."
    },
    {
      "id": "skin_gilded",
      "name": "Gilded Sovereign",
      "gems": 800,
      "days": 30,
      "main": "#e8c050",
      "trim": "#fff2b0",
      "dark": "#8a6a1a",
      "cloth": "#5a2a8a",
      "glow": "#ffe070",
      "style": "regal",
      "fx": "halo",
      "desc": "Royal gold with a winged helm and a sun on the chest. A golden halo floats over your head."
    },
    {
      "id": "skin_shadow",
      "name": "Shadow Stalker",
      "gems": 800,
      "days": 30,
      "main": "#2a2430",
      "trim": "#b060ff",
      "dark": "#141018",
      "cloth": "#1e1a24",
      "glow": "#b060ff",
      "style": "shade",
      "fx": "shadow",
      "desc": "A black cowl with burning violet eyes and shards of night on the shoulders. Dark smoke trails you."
    },
    {
      "id": "skin_storm",
      "name": "Stormcaller",
      "gems": 800,
      "days": 30,
      "main": "#2a3a5a",
      "trim": "#cfe8ff",
      "dark": "#141c2e",
      "cloth": "#1e2a44",
      "glow": "#8ad8ff",
      "style": "storm",
      "fx": "storm",
      "desc": "Storm-blue plate with a lightning crest and conductor rods. Lightning crackles around you."
    }
  ],
  "items": [
    {
      "id": "fortune_stone_1",
      "name": "Fortune Stone",
      "item": "fortune_stone",
      "qty": 1,
      "gems": 100
    },
    {
      "id": "fortune_stone_10",
      "name": "Fortune Stone x10",
      "item": "fortune_stone",
      "qty": 10,
      "gems": 900
    },
    {
      "id": "market_scroll_30",
      "name": "Market Scroll, 30 days",
      "item": "market_scroll",
      "qty": 1,
      "gems": 300,
      "days": 30
    }
  ],
  "glows": [
    {
      "id": "glow_azure",
      "name": "Azure Wisp",
      "gems": 300,
      "color": "#4ab8ff",
      "core": "#e6f6ff",
      "item": "wisp_azure",
      "days": 30
    },
    {
      "id": "glow_solar",
      "name": "Solar Wisp",
      "gems": 300,
      "color": "#ffc830",
      "core": "#fff6d0",
      "item": "wisp_solar",
      "days": 30
    },
    {
      "id": "glow_ember",
      "name": "Ember Wisp",
      "gems": 300,
      "color": "#ff5a2a",
      "core": "#ffe0c0",
      "item": "wisp_ember",
      "days": 30
    },
    {
      "id": "glow_verdant",
      "name": "Verdant Wisp",
      "gems": 300,
      "color": "#4adf6a",
      "core": "#e0ffe6",
      "item": "wisp_verdant",
      "days": 30
    },
    {
      "id": "glow_violet",
      "name": "Violet Wisp",
      "gems": 500,
      "color": "#b060ff",
      "core": "#f2e0ff",
      "item": "wisp_violet",
      "days": 30
    },
    {
      "id": "glow_prism",
      "name": "Prism Wisp",
      "gems": 800,
      "color": "#ff60c0",
      "core": "#ffffff",
      "cycle": true,
      "item": "wisp_prism",
      "days": 30
    }
  ],
  "wings": [
    {
      "id": "wings_dawn",
      "name": "Dawnfeather Wings",
      "gems": 500,
      "style": "feather",
      "main": "#f4efe2",
      "edge": "#e8b84a",
      "item": "wings_dawnfeather",
      "days": 30
    },
    {
      "id": "wings_seraph",
      "name": "Seraph Wings",
      "gems": 500,
      "style": "feather",
      "main": "#ffffff",
      "edge": "#dfeaff",
      "glow": "#eef6ff",
      "item": "wings_seraph",
      "days": 30
    },
    {
      "id": "wings_sovereign",
      "name": "Sovereign Wings",
      "gems": 500,
      "style": "feather",
      "main": "#f2c94e",
      "edge": "#fff4c0",
      "glow": "#ffe070",
      "grand": true,
      "item": "wings_sovereign",
      "days": 30
    },
    {
      "id": "wings_aurelian",
      "name": "Aurelian Wings",
      "gems": 500,
      "style": "dragon",
      "main": "#d9a83a",
      "edge": "#6a4a10",
      "glow": "#ffe070",
      "item": "wings_aurelian",
      "days": 30
    },
    {
      "id": "wings_ember",
      "name": "Emberdrake Wings",
      "gems": 500,
      "style": "dragon",
      "main": "#8a1e16",
      "edge": "#2a120e",
      "glow": "#ff7a2a",
      "item": "wings_emberdrake",
      "days": 30
    },
    {
      "id": "wings_phoenix",
      "name": "Phoenix Wings",
      "gems": 500,
      "style": "feather",
      "main": "#e8501e",
      "edge": "#ffc830",
      "glow": "#ff9a2a",
      "item": "wings_phoenix",
      "days": 30
    },
    {
      "id": "wings_nightshade",
      "name": "Nightshade Wings",
      "gems": 500,
      "style": "feather",
      "main": "#1e1a26",
      "edge": "#5a3a8a",
      "glow": "#b060ff",
      "item": "wings_nightshade",
      "days": 30
    },
    {
      "id": "wings_moon",
      "name": "Moonveil Wings",
      "gems": 500,
      "style": "fairy",
      "main": "#9a70ff",
      "edge": "#e8dcff",
      "glow": "#b890ff",
      "item": "wings_moonveil",
      "days": 30
    },
    {
      "id": "wings_frost",
      "name": "Frostveil Wings",
      "gems": 500,
      "style": "fairy",
      "main": "#8ad8ff",
      "edge": "#eaf8ff",
      "glow": "#7af0ff",
      "item": "wings_frostveil",
      "days": 30
    }
  ],
  "cloaks": [
    {
      "id": "cloak_lionheart",
      "name": "Lionheart Mantle",
      "gems": 500,
      "style": "royal",
      "cloth": "#7a1424",
      "trim": "#e8c050",
      "fur": "#f4efe6",
      "glow": "#ffd870",
      "item": "mantle_lionheart",
      "days": 30,
      "desc": "Crimson velvet lined with ermine, edged in gold, a golden sun on the back. Gold sparks drift from the hem."
    },
    {
      "id": "cloak_starweave",
      "name": "Starweave Cloak",
      "gems": 500,
      "style": "astral",
      "cloth": "#141a3a",
      "trim": "#cfe0ff",
      "glow": "#8ab8ff",
      "item": "mantle_starweave",
      "days": 30,
      "desc": "Midnight cloth woven with glowing stars, a silver crescent on the back. Starlight trails behind you."
    },
    {
      "id": "cloak_emberwake",
      "name": "Emberwake Cloak",
      "gems": 500,
      "style": "flame",
      "cloth": "#241612",
      "trim": "#ff7a2a",
      "glow": "#ff9a2a",
      "item": "mantle_emberwake",
      "days": 30,
      "desc": "Charred black cloth split by burning runes, its hem a row of flames. Embers rise in your wake."
    },
    {
      "id": "cloak_wildheart",
      "name": "Wildheart Mantle",
      "gems": 500,
      "style": "leaf",
      "cloth": "#1e4a2a",
      "trim": "#c9a94a",
      "glow": "#7aff9a",
      "item": "mantle_wildheart",
      "days": 30,
      "desc": "Forest green with a collar of leaves, glowing vines and a hem of leaf points. Green motes drift around you."
    }
  ]
}
